import AuthenticationPage from 'pages/AuthenticationPage';
import DashboardPage from 'pages/DashboardPage';
import AdvertisersPage from 'pages/AdvertisersPage';
import AddAdvertiserPage from 'pages/AddAdvertiserPage';
import CampaignsPage from 'pages/CampaignsPage';
import AddCampaignPage from 'pages/AddCampaignPage';
import AdvertsPage from 'pages/AdvertsPage';
import AddAdvertPage from 'pages/AddAdvertPage';

const routes = {
  public: [
    {
      path: '/callback',
      component: <AuthenticationPage />,
    },
  ],
  private: [
    {
      path: '/dashboard',
      component: <DashboardPage />,
    },
    {
      path: '/advertisers',
      component: <AdvertisersPage />,
    },
    {
      path: '/addAdvertiser',
      component: <AddAdvertiserPage />,
    },
    {
      path: '/addAdvertiser/:id',
      component: <AddAdvertiserPage />,
    },
    {
      path: '/campaigns',
      component: <CampaignsPage />,
    },
    {
      path: '/addCampaign',
      component: <AddCampaignPage />,
    },
    {
      path: '/addCampaign/:id',
      component: <AddCampaignPage />,
    },
    {
      path: '/adverts',
      component: <AdvertsPage />,
    },
    {
      path: '/addAdvert',
      component: <AddAdvertPage />,
    },
    {
      path: '/addAdvert/:id',
      component: <AddAdvertPage />,
    },
  ],
};

export default routes;
